import React, {useEffect, useState} from 'react'
import Description from "./Description";
import ConfigUtil from "../../../util/ConfigUtil";
import FetchUtil from "../../../util/FetchUtil";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import DHDialog from "../../general/DHDialog";
import DHTextField from "../../general/DHTextField";
import DHButtonSave from "../../general/DHButtonSave";

export default function VeranstalterVerwaltenDialog({eventOperatorID, onClose, onSave}) {

    const [tabValue, setTabValue] = React.useState("veranstalterdaten");

    let [id, setId] = useState(eventOperatorID);
    let [name, setName] = useState("");
    let [homepage, setHomepage] = useState("");
    let [socialmedia, setSocialmedia] = useState("");
    let [austragungsortBezeichnung, setAustragungsortBezeichnung] = useState("");
    let [austragungsortStrasse, setAustragungsortStrasse] = useState("");
    let [austragungsortPLZ, setAustragungsortPLZ] = useState("");
    let [austragungsortOrt, setAustragungsortOrt] = useState("");
    let [email, setEmail] = useState("");
    let [telefon, setTelefon] = useState("");

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    useEffect(() => {
        if (eventOperatorID === undefined) {
            return;
        }
        ladeVeranstalter();
    }, [eventOperatorID]);

    const getTabs = () => {
        let returnValue = [];
        returnValue.push(erzeugeTab("Veranstalterdaten" ,"veranstalterdaten", false));
        returnValue.push(erzeugeTab("Austragungsort" ,"austragungsort", false));
        return returnValue;
    }

    const erzeugeTab = (value, key, icon) => {
        return <div style={{fontSize: 16, paddingLeft:10, paddingRight:10, cursor:"pointer", borderBottom: tabValue === key ? "2px solid red" : "none", textAlign:"center"}}
                    onClick={() => setTabValue(key)}>
            {value.toUpperCase()}
        </div>
    }

    const getTabAustragungsort = () => {
        return <div>
            <h3 style={{marginBottom: 20}}>Austragungsort</h3>
            <Description
                message="Hier können Daten zum Austragungsort eingetragen werden. Diese werden in den Turnieren und Ligen als Standard vorbelegt. Natürlich können die Daten bei der Turnier-/Ligaanlage noch überschrieben werden."/>
            <div style={{marginTop: 10}}>
                <DHTextField id={"id-austragungsortbezeichnung"} label="Bezeichnung Austragungsort" value={austragungsortBezeichnung}
                             onChange={(text) => setAustragungsortBezeichnung(text)} required={false} width={"100%"}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHTextField id={"id-austragungsortstrasse"} label="Straße" value={austragungsortStrasse}
                             onChange={(text) => setAustragungsortStrasse(text)} required={false} width={"100%"}/>
            </div>
            <div className="grid" style={{marginTop: 10}}>
                <div className="col-fixed" style={{width: 200}}>
                    <DHTextField id={"id-austragungsplz"} label="PLZ" value={austragungsortPLZ}
                                 onChange={(text) => setAustragungsortPLZ(text)} required={false} width={"100%"}/>
                </div>
                <div className="col">
                    <DHTextField id={"id-austragungsort"} label="Ort" value={austragungsortOrt}
                                 onChange={(text) => setAustragungsortOrt(text)} required={false} width={"100%"}/>
                </div>
            </div>
        </div>
    }

    const getTabVeranstalterdaten = () => {
        return <div>
            <h3 style={{marginBottom: 20}}>Veranstalterdaten</h3>
            <div style={{marginTop: 10}}>
                <DHTextField id={"id-veranstaltername"} label={name.length < 3 ? "Name des Veranstalters (min. 3 Zeichen)" : "Name des Veranstalters"} value={name}
                             onChange={(text) => setName(text)} required={true} width={"100%"}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHTextField id={"id-veranstalterhomepage"} label="Homepagelink des Veranstalters" value={homepage}
                             onChange={(text) => setHomepage(text)} required={false} width={"100%"}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHTextField id={"id-veranstaltersocialmedia"} label="Socialmedialink des Veranstalters" value={socialmedia}
                             onChange={(text) => setSocialmedia(text)} required={false} width={"100%"}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHTextField id={"id-veranstaltertelefon"} label="Telefon" value={telefon}
                             onChange={(text) => setTelefon(text)} required={false} width={"100%"}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHTextField id={"id-veranstalteremail"} label="Email" value={email}
                             onChange={(text) => setEmail(text)} required={false} width={"100%"}/>
            </div>
        </div>
    }
    const getTabpanel = () => {
        if (tabValue === "veranstalterdaten") {
            return getTabVeranstalterdaten();
        } else if (tabValue === "austragungsort") {
            return getTabAustragungsort();
        } else if (tabValue === "admins") {
            return getTabAdmins();
        }
        return "";
    }

    const ladeVeranstalter = () => {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.eventoperator + "/byId/" + id,
            json => {
                setId(json.id);
                setName(json.name);
                setHomepage(json.homepage);
                setSocialmedia(json.socialmedia);
                setAustragungsortBezeichnung(json.austragungsortBezeichnung);
                setAustragungsortStrasse(json.austragungsortStrasse);
                setAustragungsortPLZ(json.austragungsortPLZ);
                setAustragungsortOrt(json.austragungsortOrt);
                setEmail(json.email);
                setTelefon(json.telefon);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const save = () => {
        setErrorMessage(undefined);

        let data = {
            id: id,
            name: name,
            socialmedia: socialmedia,
            homepage: homepage,
            austragungsortBezeichnung: austragungsortBezeichnung,
            austragungsortStrasse: austragungsortStrasse,
            austragungsortPLZ: austragungsortPLZ,
            austragungsortOrt: austragungsortOrt,
            email: email,
            telefon: telefon
        };
        let url = ConfigUtil.getConfig().resourceUrls.eventoperator + "/save";
        FetchUtil.fetchPost(url,
            data,
            json => {
                setId(json.id);
                setInfoMessage("Es wurde erfolgreich gespeichert");
                onSave();
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Speichern: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Speichern: " + error.message);
            }
        );
    }

    const footerContent = (
        <div>
            <DHButtonSave label="Speichern" onClick={() => save()} disabled={!name || name.length < 3} />
        </div>
    )

    return <DHDialog onClose={() => onClose()} title="Veranstalter verwalten" show={true} buttons={footerContent} showCloseButton={true}
                     comp={<>
                         <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                                             onClearErrorMessage={() => setErrorMessage(undefined)}/>
                         <div style={{marginTop: 10, marginBottom: 20}}>
                             <div style={{display: "flex"}}>
                                 {getTabs()}
                             </div>
                         </div>
                         {getTabpanel()}
                     </>}/>
}
